/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const getCandidateExportLogsRequestDataSchema = z.object({
	filter: z.object({
		organisation_id: z.string().uuid(),
		campaign: z.string().uuid().nullable().optional(),
		form_submission: z.string().uuid().nullable().optional(),
		status: z.union([z.literal('completed'), z.literal('failed')]).nullable().optional(),
	}),
	perPage: z.number().nullable().optional().default(15),
})

export type GetCandidateExportLogsRequestDataSchema = z.infer<typeof getCandidateExportLogsRequestDataSchema>
